import {
  AgGridEvent,
  Events,
  GridApi,
  IStatusPanelComp,
  IStatusPanelParams,
} from '@ag-grid-community/core'
import { loadTemplate } from '@ag-grid-community/core/dist/cjs/utils/dom'
import { debounce } from 'lodash-es'

const template = `
  <span class="hs-selected-status-bar hs-status-bar">
    <span>Selected: </span> <span class="value">0</span>
  </span>
`

export class SelectedRowsStatusBarComp implements IStatusPanelComp {
  private api!: GridApi
  private guiElement!: HTMLElement
  private params!: IStatusPanelParams

  private readonly selectionChangedListener = debounce(
    (ev: AgGridEvent) => this.onSelectionChange(ev),
    100,
    { maxWait: 250, trailing: true },
  ).bind(this)

  init(params: IStatusPanelParams): void {
    this.params = params
    this.api = params.api
    params.api.addEventListener(
      Events.EVENT_SELECTION_CHANGED,
      this.selectionChangedListener,
    )
  }

  onSelectionChange(ev: AgGridEvent) {
    const count = this.getRowCount(ev.api)
    const valueSpan = this.guiElement.querySelector('.value') as HTMLElement
    valueSpan.innerText = `${count}`
  }

  /**
   * @internal
   * @param ev
   */
  getRowCount(gridApi: GridApi) {
    const context:
      | {
          isSelectAllRowsEnabled?: () => boolean
          summaryData?: () => { rowCount: number }
        }
      | undefined = this.params.context

    if (
      context != null &&
      context.isSelectAllRowsEnabled != null &&
      context.isSelectAllRowsEnabled() &&
      context.summaryData != null
    ) {
      return context.summaryData().rowCount
    }

    return gridApi.getSelectedRows().length
  }

  destroy() {
    this.api.removeEventListener(
      Events.EVENT_SELECTION_CHANGED,
      this.selectionChangedListener,
    )
  }

  getGui(): HTMLElement {
    const el = loadTemplate(template)
    this.guiElement = el
    return el
  }
}
